import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import DataTable from 'react-data-table-component';
import 'antd/dist/antd.css';
import { useHistory } from "react-router-dom";
import { GET_DMT_IMPORT_BENEFICIARY_LIST, GET_DMT_NEW_BANK_LIST } from '../../../Utils/appConstants';
import { getRequest } from '../../../Utils/AppApi';
import { ToastContainer } from 'react-toastify';
import { importDmtVersion, isNumber } from '../../../Utils/Common';
import { getUTCToLocalDateFormat } from './../../../Utils/function';
import Select from 'react-select';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

function Import(props) {
    const history = useHistory();
    const limit = 10;
    const [getData, setData] = useState([]);
    const [isLimit, setLimit] = useState(limit);
    const [page, setPage] = useState(1);
    const [saveCustomerMobile, setCustomerMobile] = useState(props.customerMobile);
    const [searchText, setSearchText] = useState(null);
    const [timer, setTimer] = useState(null);
    const [bankId, setBankId] = useState(null);
    const [bankName, setBankName] = useState('');
    const [isAddBaneModal, setAddBaneModal] = useState(false);
    const [getBeneData, setBeneData] = useState({});
    const [getBeneError, setBeneError] = useState({});
    const [getEKOBankListData, setEKOBankListData] = useState([]);
    const [getBankListData, setBankListData] = useState([{ "value": '', "label": '-- Select Bank --' }]);
    const [selectedOption, setSelectedOption] = useState(null);

    const columns = [
        {
            name: 'Nick Name',
            selector: row => <><div>{row.beneName}</div>{row.beneMobile && <div><strong>Mobile</strong>: {row.beneMobile}</div>}</>,
        },
        {
            name: 'IFSC / Bank',
            selector: row => <><div><strong>IFSC</strong>: {row.ifscCode}</div>{row.bankName && <div><strong>Bank</strong>: {row.bankName}</div>}</>,
        },
        {
            name: 'Account',
            selector: row => <><div>{row.accountNumber}</div><div><strong>UP</strong>: {getUTCToLocalDateFormat(row.updatedAt)}</div></>,
        },
        {
            name: 'Bene Name',
            selector: row => <><div><strong>{row.isVerified ? <CheckOutlined className='text-120 text-success border p-1' /> : <CloseOutlined className='text-120 text-danger border p-1'/> }</strong> {row.beneBankName} </div></>,
        },
        {
            name: 'Action',
            selector: (row) => <><Button className={"bg-primary"} onClick={() => addBane(row)} small >Add</Button></>,
            fixed: "right",
        },
        {
            name: 'Version',
            selector: row => importDmtVersion(row?.apiName),
        },
    ];

    // ---- Fetch bank list without filtering by mode ----
    const getBankList = () => {
        getRequest(GET_DMT_NEW_BANK_LIST, history).then((response) => {
            if (response.success === true) {
                let bankDataRecord = response.data || [];
                // No filtering by mode – all banks are available for selection
                setEKOBankListData(bankDataRecord);
                setBankListData([
                    { value: '', label: '-- Select Bank --' },
                    ...bankDataRecord.map((item) => ({
                        "value": item.BankID,
                        "label": item.BANK_NAME
                    }))
                ]);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };

    // ---- Load bank list on mount ----
    useEffect(() => {
        getBankList();
    }, []);

    // ---- addBane: preselect bank if it exists in the list ----
    const addBane = (data) => {
        setBeneData(data);

        let selectedBank = null;

        // Priority 1: Match by bankId / BankID
        if (data.bankId || data.BankID) {
            const bankIdToSearch = data.bankId || data.BankID;
            selectedBank = getEKOBankListData.find(item => item.BankID === bankIdToSearch);
        }

        // Priority 2: Match by bank name (case-insensitive)
        if (!selectedBank && (data.bankName || data.beneBankName)) {
            const bankNameToSearch = (data.bankName || data.beneBankName || "").trim().toLowerCase();
            selectedBank = getEKOBankListData.find(item => 
                item.BANK_NAME && item.BANK_NAME.toLowerCase() === bankNameToSearch
            );
        }

        if (selectedBank) {
            const option = {
                value: selectedBank.BankID,
                label: selectedBank.BANK_NAME
            };
            setSelectedOption(option);
            setBankId(selectedBank.BankID);
            setBankName(selectedBank.BANK_NAME);
        } else {
            setSelectedOption(null);
            setBankId(null);
            setBankName('');
        }

        setAddBaneModal(true);
    };

    const onChangeBankIfscCode = (value) => {
        if (value) {
            let findBank = getEKOBankListData.find(item => item.BankID === value);
            if (findBank) {
                setSelectedOption({
                    value: findBank.BankID,
                    label: findBank.BANK_NAME
                });
                setBankId(findBank.BankID);
                setBankName(findBank.BANK_NAME);

                if (findBank.ifsc) {
                    setBeneData(prev => ({ ...prev, ifscCode: findBank.ifsc }));
                }
            }
        } else {
            setSelectedOption(null);
            setBankId(null);
            setBankName('');
        }
    };

    const FormBaneValidate = () => {
        let formValid = true;
        let formObject = {};
        setBeneError({});

        if (!bankId || bankId === "" || typeof bankId === "undefined") {
            formObject.bankName = true;
            formValid = false;
        }
        setBeneError(formObject);
        return formValid;
    };

    const onChangeAddBene = (event) => {
        let { name, value } = event.target;
        setBeneData({ ...getBeneData, [name]: value });
    };

    const addBaneSave = () => {
        if (FormBaneValidate() === true) {
            const payload = {
                customerMobile: props.customerMobile,
                recipientMobile: getBeneData.beneMobile,
                accountNumber: getBeneData.accountNumber,
                ifscCode: getBeneData.ifscCode,
                bankId: bankId,
                bankName: bankName,
                recipientName: getBeneData.beneName,
                beneBankName: getBeneData.beneBankName
            };
            props.addBaneficiary(payload);
        }
    };

    const handleHideModal = () => {
        setAddBaneModal(false);
        setSelectedOption(null);
        setBankId(null);
        setBankName('');
    };

    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    };

    const params = { page: page, limit: isLimit };

    const getDataReports = (data) => {
        if (data) {
            setLimit(data);
            params.limit = data;
        }
        if (searchText) {
            params.search = searchText;
        }
        params.mode = props.mode;
        params.customerMobile = saveCustomerMobile;
        const queryString = objectToQueryString(params);
        getRequest(`${GET_DMT_IMPORT_BENEFICIARY_LIST}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
            } else {
                setPage(1);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };

    const handlePageChange = page => {
        setPage(page);
    };

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        setCustomerMobile(props.customerMobile);
        getDataReports();
    }, [props.customerMobile]);

    useEffect(() => {
        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                getDataReports();
            }, 100)
        );
    }, [searchText]);

    return (
        <div>
            <div className="pt-2 pb-5">
                <div className="col-md-12">
                    <div className="row pb-3">
                        <div className='col-md-8 date-search'>
                            <div className='row'>
                                <div className="input-group">
                                    <input 
                                        className="form-control py-2 border-right-0 border" 
                                        type="search" 
                                        value={searchText || ''} 
                                        onKeyDown={isNumber} 
                                        placeholder='Search Account Number ...' 
                                        maxLength={20} 
                                        onChange={(e) => handleSearch(e)} 
                                    />
                                    <input 
                                        className="form-control py-2 border" 
                                        type="text" 
                                        value={saveCustomerMobile} 
                                        onKeyDown={isNumber} 
                                        placeholder='Search Customer Number ...' 
                                        maxLength={20} 
                                        onChange={(e) => setCustomerMobile(e.target.value)} 
                                    />
                                    <button 
                                        className="btn border btn-primary ml-2" 
                                        type="button" 
                                        onClick={() => getDataReports()}
                                    >
                                        <i className="fa fa-search" /> Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="box-body">
                        <DataTable
                            columns={columns}
                            data={getData.docs || []}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={getData.totalDocs || 0}
                            onChangeRowsPerPage={getDataReports}
                            onChangePage={handlePageChange}
                        />
                    </div>
                </div>
            </div>

            <ToastContainer 
                position="top-center" 
                autoClose={5000} 
                limit={2} 
                hideProgressBar={false} 
                newestOnTop={false} 
                closeOnClick 
                rtl={false} 
                pauseOnFocusLoss 
                draggable 
                pauseOnHover 
                theme="colored" 
            />

            {/* Add Beneficiary Confirmation Modal */}
            {isAddBaneModal && (
                <Modal 
                    title={"Confirm Bank Account"} 
                    width={400} 
                    open={isAddBaneModal} 
                    onOk={() => addBaneSave()} 
                    onCancel={handleHideModal} 
                    okText={"Confirm"} 
                    cancelText={"Cancel"}
                >
                    <div className='row'>
                        <div className="form-group col-lg-12 col-md-12">
                            <label>Mobile (Optional)</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="beneMobile" 
                                placeholder="Mobile Number" 
                                autoComplete="off" 
                                onChange={onChangeAddBene} 
                                value={getBeneData.beneMobile || ''} 
                                readOnly={props.mode === "DMT" ? false : true} 
                                maxLength={10} 
                                onKeyDown={isNumber} 
                            />
                        </div>

                        <div className="form-group col-lg-12 col-md-12">
                            <label>Account Holder Name</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="name" 
                                value={getBeneData.beneName || ''} 
                                readOnly 
                            />
                        </div>

                        <div className="form-group col-lg-12 col-md-12">
                            <label>Bank Name</label>
                            {/* {getBeneData.bankName && (
                                <small className="text-muted d-block mb-1">
                                    Imported: <strong>{getBeneData.bankName}</strong>
                                </small>
                            )} */}
                            <Select 
                                options={getBankListData} 
                                className="normal-light w-100" 
                                value={selectedOption}
                                classNamePrefix="select" 
                                placeholder="-- Select Bank --" 
                                onChange={(e) => onChangeBankIfscCode(e ? e.value : null)} 
                            />
                            {getBeneError && getBeneError.bankName && (
                                <span className="error text-danger">Please select bank</span>
                            )}
                        </div>

                        <div className="form-group col-lg-12 col-md-12">
                            <label>Global IFSC Code</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="ifscCode" 
                                value={getBeneData.ifscCode || ''} 
                                readOnly 
                            />
                        </div>

                        <div className="form-group col-lg-12 col-md-12">
                            <label>Account Number</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="accountNumber" 
                                value={getBeneData.accountNumber || ''} 
                                readOnly 
                            />
                        </div>

                        {getBeneData.beneBankName && (
                            <div className="form-group col-lg-12 col-md-12">
                                <label>Bene Bank Name</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    value={getBeneData.beneBankName} 
                                    readOnly 
                                />
                            </div>
                        )}
                    </div>
                </Modal>
            )}
        </div>
    );
}

export default Import;